<template>
  <svg width="1348" height="287" viewBox="0 0 1348 287" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3802_6743)">
      <path opacity="0.2" d="M1628.41 391.853L1620.23 391.372C1618.69 367.322 1616.67 336.345 1614.36 301.136L500.071 271.602L-27.9746 257.653L-32.6885 257.557L-27.9746 195.219V154.141L-28.648 154.43L-30.0911 155.007L-29.3215 145.291L-27.8784 126.532L-26.243 105.079C-26.243 105.079 56.2009 47.4546 158.077 41.4902C224.36 37.6422 305.168 90.0716 364.524 87.5703C423.88 85.0691 450.527 24.1741 513.443 7.62759C576.358 -8.91892 696.031 70.158 759.813 47.7432C823.594 25.3285 843.796 -118.684 924.797 -136.096C1005.8 -153.509 1145.87 -39.3183 1145.87 -39.3183C1145.87 -39.3183 1562.03 -291.749 1574.05 -292.422C1580.31 -292.807 1594.55 -110.603 1606.96 65.9252C1607.24 69.9656 1607.53 73.9098 1607.82 77.9503L1608.4 85.7425C1613.98 166.455 1619.17 244.377 1622.83 301.521C1626.2 356.355 1628.41 391.853 1628.41 391.853Z" fill="url(#paint0_linear_3802_6743)" />
      <path opacity="0.2" d="M1630.91 427.351L1622.44 426.87C1621.87 417.924 1621.1 405.899 1620.23 391.469C1618.69 367.418 1616.67 336.442 1614.36 301.232L500.071 271.603L-27.9746 257.653L-32.6885 257.557L-27.9746 195.219L-24.8 152.987L-24.0304 142.116L-22.9722 128.071C-22.9722 128.071 70.0538 62.5585 171.93 68.2344C255.432 72.852 307.477 125.57 366.833 123.069C426.189 120.568 459.186 57.5561 522.197 41.1058C585.112 24.5592 714.117 127.302 777.898 104.887C841.679 82.472 846.201 -83.0893 927.202 -100.502C1008.11 -118.01 1148.27 -3.81997 1148.27 -3.81997C1148.27 -3.81997 1564.43 -256.251 1576.46 -256.924C1582.23 -257.213 1595.12 -98.5777 1606.86 66.0217C1607.15 70.0621 1607.44 74.0063 1607.73 78.0468L1608.3 85.8391C1613.79 162.992 1618.88 240.145 1622.92 301.617C1627.73 375.98 1630.91 427.351 1630.91 427.351Z" fill="url(#paint1_linear_3802_6743)" />
      <path opacity="0.2" d="M1614.46 301.232L500.071 271.602L-27.9746 257.653L-32.6885 257.557L-27.9746 195.219V154.141L-28.648 154.43L-30.0911 155.007C-30.3797 155.103 -30.6683 155.199 -30.8607 155.392L-30.0911 145.772L-29.2253 145.291C-28.8405 145.098 -28.3594 144.81 -27.7822 144.425C-26.8202 143.848 -25.4734 142.982 -23.7418 142.02C-3.15487 130.187 65.9172 94.1119 150.862 89.1095C217.145 85.2615 335.568 172.9 390.402 150.293C443.216 128.552 459.666 92.9576 524.698 90.8412C612.818 88.0513 719.985 156.258 783.766 133.747C847.547 111.236 914.599 -39.8956 995.696 -57.3079C1076.79 -74.7202 1141.15 13.6882 1141.15 13.6882C1141.15 13.6882 1557.32 -238.742 1569.34 -239.416C1577.71 -239.8 1601.28 100.365 1614.46 301.232Z" fill="url(#paint2_linear_3802_6743)" />
      <path d="M502.957 279.921C502.957 279.921 436.579 345.434 428.017 343.125C426.862 342.836 416.28 341.778 398.868 340.239C317.675 333.12 87.9474 314.938 -27.9744 305.799V264.048L-32.6882 263.952L-27.9744 201.614V160.536C-26.9162 160.151 -25.858 159.767 -24.7998 159.382C10.8907 147.453 51.9683 163.037 72.3629 178.622C107.765 205.654 120.848 229.32 154.614 233.745C160.771 234.514 167.024 234.707 173.181 234.322C221.762 231.629 211.469 199.69 257.742 175.159C260.05 173.908 262.455 172.85 264.86 171.888C309.209 153.995 356.155 184.009 356.155 184.009L500.071 278.19L502.957 279.921Z" fill="url(#paint3_linear_3802_6743)" />
      <path d="M1542.12 240.4V293.214H28.0151C273.231 235.397 528.74 206.826 781.555 198.552C829.751 197.013 877.948 196.147 926.241 196.244C949.136 196.244 971.84 196.436 994.543 196.725C1154.62 199.13 1309.5 210.193 1456.98 228.759C1485.65 232.319 1514.03 236.167 1542.12 240.4Z" fill="url(#paint4_linear_3802_6743)" />
      <path d="M986.463 202.881C997.673 202.881 1006.76 202.58 1006.76 202.208C1006.76 201.836 997.673 201.534 986.463 201.534C975.252 201.534 966.165 201.836 966.165 202.208C966.165 202.58 975.252 202.881 986.463 202.881Z" fill="#35185E" />
      <path d="M795.12 210.577C817.434 210.577 835.524 209.457 835.524 208.076C835.524 206.695 817.434 205.575 795.12 205.575C772.805 205.575 754.715 206.695 754.715 208.076C754.715 209.457 772.805 210.577 795.12 210.577Z" fill="#35185E" />
      <path d="M531.452 222.05C551.332 220.716 567.41 219.075 567.364 218.386C567.318 217.697 551.164 218.22 531.284 219.554C511.404 220.889 495.326 222.529 495.372 223.218C495.419 223.907 511.572 223.384 531.452 222.05Z" fill="#361269" />
      <path d="M1459.46 257.974C1459.64 254.792 1427.29 250.326 1387.19 248C1347.09 245.674 1314.43 246.368 1314.25 249.55C1314.06 252.733 1346.42 257.198 1386.52 259.524C1426.62 261.85 1459.27 261.156 1459.46 257.974Z" fill="#210B40" />
      <path d="M924.798 241.65C941.003 241.65 954.139 240.229 954.139 238.475C954.139 236.722 941.003 235.301 924.798 235.301C908.594 235.301 895.457 236.722 895.457 238.475C895.457 240.229 908.594 241.65 924.798 241.65Z" fill="#2A124A" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3802_6743"
        x1="305.9"
        y1="-341.416"
        x2="1810.04"
        y2="706.805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F56088" />
        <stop offset="0.03" stop-color="#E1598D" stop-opacity="0.85" />
        <stop offset="0.07" stop-color="#C75093" stop-opacity="0.65" />
        <stop offset="0.12" stop-color="#B04899" stop-opacity="0.48" />
        <stop offset="0.17" stop-color="#9C429D" stop-opacity="0.33" />
        <stop offset="0.22" stop-color="#8D3CA1" stop-opacity="0.21" />
        <stop offset="0.27" stop-color="#8038A4" stop-opacity="0.12" />
        <stop offset="0.33" stop-color="#7835A6" stop-opacity="0.05" />
        <stop offset="0.39" stop-color="#7334A8" stop-opacity="0.01" />
        <stop offset="0.48" stop-color="#7133A8" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3802_6743"
        x1="311.111"
        y1="-320.893"
        x2="1821.55"
        y2="731.725"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F56088" />
        <stop offset="0.03" stop-color="#E1598D" stop-opacity="0.85" />
        <stop offset="0.07" stop-color="#C75093" stop-opacity="0.65" />
        <stop offset="0.12" stop-color="#B04899" stop-opacity="0.48" />
        <stop offset="0.17" stop-color="#9C429D" stop-opacity="0.33" />
        <stop offset="0.22" stop-color="#8D3CA1" stop-opacity="0.21" />
        <stop offset="0.27" stop-color="#8038A4" stop-opacity="0.12" />
        <stop offset="0.33" stop-color="#7835A6" stop-opacity="0.05" />
        <stop offset="0.39" stop-color="#7334A8" stop-opacity="0.01" />
        <stop offset="0.48" stop-color="#7133A8" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3802_6743"
        x1="308.343"
        y1="-311.459"
        x2="1730.02"
        y2="679.302"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F56088" />
        <stop offset="0.03" stop-color="#E1598D" stop-opacity="0.85" />
        <stop offset="0.07" stop-color="#C75093" stop-opacity="0.65" />
        <stop offset="0.12" stop-color="#B04899" stop-opacity="0.48" />
        <stop offset="0.17" stop-color="#9C429D" stop-opacity="0.33" />
        <stop offset="0.22" stop-color="#8D3CA1" stop-opacity="0.21" />
        <stop offset="0.27" stop-color="#8038A4" stop-opacity="0.12" />
        <stop offset="0.33" stop-color="#7835A6" stop-opacity="0.05" />
        <stop offset="0.39" stop-color="#7334A8" stop-opacity="0.01" />
        <stop offset="0.48" stop-color="#7133A8" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3802_6743"
        x1="176.928"
        y1="104.112"
        x2="176.928"
        y2="288.413"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stop-color="#9133C2" />
        <stop offset="0.924058" stop-color="#1C0C32" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3802_6743"
        x1="806.708"
        y1="-39.9644"
        x2="810.394"
        y2="276.505"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.43" stop-color="#9133C2" />
        <stop offset="0.96526" stop-color="#1C0C32" />
      </linearGradient>
      <clipPath id="clip0_3802_6743">
        <rect width="1348" height="287" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {}
</script>
